module.exports = "<g class='metro-svg-browser__change' ng-attr-stroke='{$ ::changeCtrl.changeData.stroke $}' ng-bind-html='::changeCtrl.trust(changeCtrl.changeData.html)' />\n<g class='metro-svg-browser__change_white' ng-bind-html='::changeCtrl.trust(changeCtrl.changeData.html)' />\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/metro-browser/templates/metro-svg-browser.change.html
// module id = 396
// module chunks = 0